import './App.css';
import RealEstateUpload from "./RealEstateUpload";

function App() {
  return (
    <RealEstateUpload/>
  )
}

export default App;
